// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".export-warning[data-v-0c62ed06]{margin:10px 0}.export-warning .el-alert[data-v-0c62ed06]{margin:0}", ""]);
// Exports
module.exports = exports;
